// extracted by mini-css-extract-plugin
export default {"tooltip":"vo-z","sharingV2":"wo-z","sharingIconsV2":"xo-z","links":"yo-z","link":"zo-z","facebookV2":"Ao-z","twitterV2":"Bo-z","pinterestV2":"Co-z"};